import type { ReactNode } from 'react'
import { isEmpty } from 'lodash-es'

import type { PollDto, PollOptionDto } from '../api/polls'

export type PollState = 'start' | 'finish' | 'publish' | 'unpublish'

type PollOption = {
  id: number
  option: string
  answerCount?: number
  answerPercentage?: number | string
  answerPercentageFmt?: string
}

const mapDtoToPollOption = (dto: PollOptionDto): PollOption => ({
  id: dto.poll_option_id,
  option: String(dto.option),
  answerCount: dto.answer_count,
  answerPercentage: dto.answer_percentage,
  answerPercentageFmt: dto.answer_percentage_fmt,
})

type Poll = {
  pollId: number
  objectId: number
  objectType: 'live' // only live supported atm.
  question: string
  openedDate: string
  optionsCount: number
  open: boolean
  displayResults: boolean
  answerCount?: number
  options: Array<PollOption>
  state: PollState
}

export type PollUnitWrapperProps = {
  title?: string
  isPollActive?: boolean
  renderHeaderAction?: () => ReactNode
  children: ReactNode
}

export type RenderPollUnitWrapper = (props: PollUnitWrapperProps) => JSX.Element

const getPollState = (poll: PollDto): PollState => {
  if (poll.open_p) {
    return 'finish'
  }

  if (poll.display_results_p) {
    return 'unpublish'
  }

  if (!isEmpty(poll.opened_date)) {
    return 'publish'
  }

  return 'start'
}

export const mapDtoToPoll = (dto: PollDto): Poll => ({
  pollId: dto.poll_id,
  objectId: dto.object_id,
  objectType: dto.object_type,
  question: String(dto.question),
  openedDate: dto.opened_date,
  optionsCount: dto.options_count,
  open: dto.open_p,
  displayResults: dto.display_results_p,
  answerCount:
    dto.answer_count ??
    dto.options.reduce(
      (total, option) => total + (option.answer_count ?? 0),
      0
    ),
  options: dto.options.map(mapDtoToPollOption),
  state: getPollState(dto),
})

export type { Poll }
